import { useEffect } from "react";

export default function useScrollToHash() {
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    };

    // Run on load (with small delay to wait for render)
    const timeout = setTimeout(scrollToHash, 300);

    // Run when hash changes (like /#contact → /#about)
    window.addEventListener("hashchange", scrollToHash);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);
}
